import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background-color: #fff;
  z-index: 1;
  margin: auto;
  width: 25rem;
  border-radius: 1vw;
  padding: 1.5rem;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const CloseDiv = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;

  &:hover{
    background-color: #F4F4F4;
  }
`

export const InputDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: .3rem;
  margin-top: .8rem;
`

export const InputData = styled.input`
  width: 100%;
  border: none;
  outline: none;
  background-color: #EBEBEB;
  height: 2.98rem;
  padding: 0 1rem;
  border-radius: 2rem;
`

export const InputLabel = styled.label`
  display: block;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: clamp(0.78rem, calc(0.78rem + 0.1vw) , 1.6rem);
`

export const BottomDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
  gap:1.5rem;

  span{
    color:red;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 2rem;
  gap: 1rem;
`

export const ButtonDiv = styled.div`
  background-color: #0090D3;
  color: #fff;
  padding: 1rem 1.6rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap:.5rem;
  border-radius: 1.5rem;
  user-select: none;
  cursor: pointer;
  img{
    width: 1rem;
  }
  &.cancel{
    border: 1px solid #0090D3;
    color: #0090D3;
    background-color: #fff;
  }
  &.inactive{
    color:rgb(202, 202, 202);
    background-color:rgb(145, 145, 145);
    cursor: not-allowed;
  }
`